// @flow
import { connect } from "react-redux";

import type { AbstractComponent, ComponentType } from "react";
import type { ReduxState, PreferenceValue, PreferencesState } from "../types";

type StateProps = {
  [prefName: string]: PreferenceValue,
};

type OwnProps = {};

type Props = {
  ...StateProps,
  ...OwnProps,
  dispatch: void,
};

/**
 */
const getPreferences = (
  preferences: PreferencesState,
  preferenceName: string | Array<string>,
) => {
  const requestedPreferences = Array.isArray(preferenceName)
    ? preferenceName
    : [preferenceName];

  const prefs: $Shape<StateProps> = {};

  requestedPreferences.forEach((prefName) => {
    prefs[prefName] = preferences[prefName];
  });

  return prefs;
};

/**
 * Injects a preference by name into a react component
 *
 * @deprecated - will be removed in the future, use the equivalent hook 'usePreference' instead
 */
export const connectPreferences = (
  WrappedComponent: AbstractComponent<any>,
  preferenceName: string | Array<string>,
): ComponentType<any> => {
  /**
   */
  const mapStateToProps = (state: ReduxState): StateProps =>
    getPreferences(state.preferences, preferenceName);

  return connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(
    WrappedComponent,
  );
};
